import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/pay/:orderId",
    name: "PaymentView",
    component: () => import("../views/PaymentView.vue"),
  },
  {
    path: "/success",
    name: "SuccessView",
    component: () => import("../views/SuccessView.vue"),
  },
  {
    path: "/baogao",
    name: "BaogaoView",
    component: () => import("../views/BaogaoView.vue"),
  },
  {
    path: "/s",
    name: "SearchView",
    component: () => import("../views/SearchView.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
